module.exports = __webpack_public_path__ + "Emotional-3119ad6d277c3ff10ea1d5488fc72259.png";